/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KioskAffiliatedUserDto } from '../../models/kiosk-affiliated-user-dto';
import { KioskPinDto } from '../../models/kiosk-pin-dto';

export interface ApiKioskSearchByPinPost$Params {
  'api-version'?: string;
      body?: KioskPinDto
}

export function apiKioskSearchByPinPost(http: HttpClient, rootUrl: string, params?: ApiKioskSearchByPinPost$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskAffiliatedUserDto>> {
  const rb = new RequestBuilder(rootUrl, apiKioskSearchByPinPost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KioskAffiliatedUserDto>;
    })
  );
}

apiKioskSearchByPinPost.PATH = '/api/kiosk/search-by-pin';
